<template>
  <div class="recipe-facets-filter" v-if="facetGroups.length" :class="{ 'is-mobile': isMobile }" ref="facetsFilter">
    <div
      class="facet-group"
      :class="{ 'is-open': group.expanded }"
      v-for="group in facetGroups"
      :key="group.Specification || group.Label"
      v-if="group.Label && group.Options && group.Options.length"
    >
      <div  class="facet-group__header" @click="toggleGroup(group)">
        <span class="facet-group__title">{{ group.Label }}</span>
        <span class="facet-group__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M9.5 4L6 7.5L2.5 4" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>
      <div class="facet-group__content" v-show="group.expanded">
        <div v-for="opt in group.Options" :key="makeId(group, opt)" class="facet-row">
          <input
          :id="makeId(group, opt)"
            type="checkbox"
            :value="opt.Value || opt.Name"
            v-model="group.selectedValues"
            @change="onGroupChange(group)"
          />
          <label
            class="facet-option"
            :for="makeId(group, opt)"
          >
            <span class="facet-option__label">{{ opt.Name }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'RecipeFacetsFilter',
  props: {
    filters: {
      type: [Array, Object],
      default: null
    }
  },
  computed: mapState({
    pagination: state => state.listing.pagination,
    specification: state => state.listing.specification,
  }),
  data() {
    return {
      facetGroups: [],
      isMobile: false
    };
  },
  mounted() {
    this.isMobile = (typeof window !== 'undefined') ? window.innerWidth < 992 : false;
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('click', this.handleDocumentClick);
    }
    this.loadFilters();
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.handleDocumentClick);
    }
  },
  watch: {
    filters: {
      handler() {
        this.loadFilters();
      },
      deep: true
    },
    specification: {
      handler() {
        this.facetGroups.forEach(group => {
          const key = group.Specification || group.Label;
          const selectedValues = this.specification[key] || [];

          this.$set(group, 'selectedValues', Array.isArray(selectedValues) ? selectedValues.slice() : [selectedValues]);
        });
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
    loadFilters() {
      const source = this.filters || ((window && window.Launchpad && window.Launchpad.RecipeFilters) || []);
      const groups = Array.isArray(source) ? source : [source];
      // on mobile start collapsed, on desktop expanded
      this.facetGroups = groups
        .filter(function (group) { return group && group.Label && Array.isArray(group.Options) && group.Options.length; })
        .map(group => ({
          ...group,
          expanded: !this.isMobile,
          selectedValues: (this.specification[group.Specification || group.Label] || []).slice()
        }));
    },
    toggleGroup(group) {
      const shouldExpand = !group.expanded;

      if (this.isMobile && shouldExpand) {
        this.facetGroups.forEach(g => {
          if (g !== group) {
            g.expanded = false;
          }
        });
      }

      group.expanded = shouldExpand;
    },
    handleDocumentClick(event) {
      if (
        !this.isMobile ||
        !this.$refs.facetsFilter ||
        this.$refs.facetsFilter.contains(event.target)
      ) {
        return;
      }

      this.facetGroups.forEach(group => {
        group.expanded = false;
      });
    },
    makeId(group, opt) {
      const g = (group.Specification || group.Label || '').toString().replace(/\s+/g, '-').toLowerCase();
      const o = (opt.Value || opt.Name || '').toString().replace(/\s+/g, '-').toLowerCase();
      return `facet-${g}-${o}`;
    },
    onGroupChange(group) {
      const spec = group.Specification || group.Label;
      const values = group.selectedValues || [];

      this.updateSpecification({ key: spec, value: values });
    },
    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = (typeof window !== 'undefined') ? window.innerWidth < 992 : false;
      if (wasMobile !== this.isMobile) {
        // when switching between mobile/desktop set sensible defaults
        this.facetGroups.forEach(g => { g.expanded = !this.isMobile; });
      }
    }
  }
};
</script>
